import { ActiveBundlePageTypeKeys } from '@/store';
import { bundleTypeMap } from '../constants';
import { api } from '../core';

interface CreateTimelineEntryResponse {
  entryId: string;
}

interface CreateTimelineEntryProps {
  abortController?: AbortController;
  caseId: string;
  bundlePageType: ActiveBundlePageTypeKeys;
  timelineEntry: CreateTimelineEntry;
}
interface CreateTimelineEntry {
  date: string; // '2025-01-01';
  time: string | null;
  providerId: string | null;
  summary: string;
  comment: string;
  bundlePageNumbers: number[];
}
const timelineEntryCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTimelineEntry: builder.query<CreateTimelineEntryResponse, CreateTimelineEntryProps>({
      query: ({
        abortController = new AbortController(),
        caseId,
        bundlePageType,
        timelineEntry: { date, time, providerId, summary, comment, bundlePageNumbers }
      }: CreateTimelineEntryProps) => ({
        url: 'timeline/entry/create',
        method: 'POST',
        body: {
          case_id: caseId,
          bundle_type_to_add_from: bundleTypeMap[bundlePageType],
          timeline_entry: {
            date,
            time,
            provider_id: providerId,
            summary,
            comment,
            bundle_page_numbers: bundlePageNumbers
          }
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in createTimelineEntry in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyCreateTimelineEntryQuery } = timelineEntryCreateApi;
